import style from "@/styles/pages/Login/Login.module.css";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { createApiClient } from "@/lib/Requests";
import { useEffect, useState } from "react";
import { RootState } from "@/store/dtm";
import { useForm } from "react-hook-form";
import FadeTransition from "@/styles/animation/FadeTransition";
import { UpdatePasswordDto } from "@/lib/DTMWebAPIClient.generated";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function NewPassword() {
    const client = createApiClient({ timeout: 60000 });
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [passwordShown, setPasswordShown] = useState(false);
    const [displayError, setDisplayError] = useState(false);
    const [resetToken, setResetToken] = useState("");
    const [resetInProgress, setResetInProgress] = useState(false);

    const [lcCriteriaMatch, setLcCriteriaMatch] = useState(false);
    const [ucCriteriaMatch, setUcCriteriaMatch] = useState(false);
    const [numCriteriaMatch, setNumCriteriaMatch] = useState(false);
    const [lenCriteriaMatch, setLenCriteriaMatch] = useState(false);
    const [scCriteriaMatch, setScCriteriaMatch] = useState(false);
    const [pwdCriteriaMatch, setPwdCriteriaMatch] = useState(false);

    const application = useSelector(
        (state: RootState) => state.application.application
    );

    const methods = useForm({
        defaultValues: {
            password: "",
            confirmpassword: ""
        },
    });

    useEffect(() => {
        if (searchParams.get("token") != undefined) {
            let filteredToken = searchParams.get("token")!.replaceAll("{", "").replaceAll("}", "");
            setResetToken(filteredToken);
        }
    }, []);

    const onError = (errors: object) => {

    }

    const onSubmit = (data: any) => {
        console.log(data);
        setResetInProgress(true);
        setDisplayError(false);
        client.apiAuthUpdatepassword(resetToken, new UpdatePasswordDto({
            applicantId: 0,
            password: data.confirmpassword,
            clientToken: resetToken
        })).then((result) => {
            setResetInProgress(false);
            navigate("/login", { replace: true, state: { passwordChanged: true } });


        }).catch((error) => {
            setResetInProgress(false);
            setDisplayError(true);
            console.log("Error resetting pasword", error);
        });
    };

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const handleChange = (e: { target: { value: string } }) => {
        setLcCriteriaMatch(/[a-z]/.test(e.target.value));
        setUcCriteriaMatch(/[A-Z]/.test(e.target.value));
        setNumCriteriaMatch(/\d/.test(e.target.value));
        setLenCriteriaMatch(/^.{8,12}$/gm.test(e.target.value));

        const specialCharacters = /[/<>,]/.test(e.target.value);
        setScCriteriaMatch(
            specialCharacters || e.target.value == "" ? false : true
        );
    };

    const handlePasswordConfirmation = (e: { target: { value: string } }) => {
        setPwdCriteriaMatch(e.target.value == methods.getValues("password"));
    };

    return (
        <main aria-labelledby="main-content">
            <div className="main-container max-md:mt-10">
                <form onSubmit={methods.handleSubmit(onSubmit, onError)}>
                    <div className={clsx(style.login, "container", "mt-10")}>
                        <div className={style.emHeading}>
                            <div className="grid grid-cols-1">
                                <h1>Create a new password</h1>
                                {window.screen?.width <= 768 && 
                                    <p>Create a new, strong password that you don’t use for other websites</p>
                                }
                                {window.screen?.width > 768 && 
                                <>
                                    <p>Create a new, strong password that you don’t use for</p>
                                    <p style={{marginTop: 0}}>other websites. </p>
                                </>}
                            </div>
                        </div>
                        {displayError &&
                            <div className={clsx("flex flex-row pcaautocomplete mt-5", style.errorContainer)}>
                                <img src="assets/error-info-icon.svg" alt="error" />
                                <span className="text-sm ml-2 mt-1">
                                    Sorry, we were unable to reset your password; please try again later or call the contact centre.
                                </span>
                            </div>
                        }
                        <div className="mt-5">
                            <label htmlFor="email">Enter New Password</label>
                            <div className="flex relative">
                                <span className={clsx(passwordShown ? "hidden" : " ")}>
                                    <img
                                        onClick={togglePasswordVisiblity}
                                        src="assets/eye-icon.svg"
                                        className={clsx(
                                            "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                                        )}
                                        alt="error"
                                        height={5}
                                        width={5}
                                    />
                                </span>
                                <span className={clsx(passwordShown ? " " : "hidden")}>
                                    <img
                                        onClick={togglePasswordVisiblity}
                                        src="assets/eye-slash-icon.svg"
                                        className={clsx(
                                            "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                                        )}
                                        alt="error"
                                        height={5}
                                        width={5}
                                    />
                                </span>
                                <input
                                    className={clsx(
                                        "mt-2"
                                    )}
                                    type={passwordShown ? "text" : "password"}
                                    id="password"
                                    {...methods.register("password", {
                                        onChange: (e) => {
                                            handleChange(e);
                                        },
                                        required: "Enter a password",
                                        minLength: {
                                            value: 8,
                                            message: "Password must have at least 8 characters",
                                        },
                                        maxLength: {
                                            value: 12,
                                            message:
                                                "Password must have no more than 12 characters",
                                        },
                                        pattern: {
                                            value:
                                                /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*[//<>,]).{8,12})+$/,
                                            message: "Password must match criteria",
                                        },
                                    })}
                                />
                            </div>
                        </div>
                        <div className="mt-3 pass-wrapper">
                            <label htmlFor="password">Confirm New Password</label>
                            <div className="flex relative">
                                <span className={clsx(passwordShown ? "hidden" : " ")}>
                                    <img
                                        onClick={togglePasswordVisiblity}
                                        src="assets/eye-icon.svg"
                                        className={clsx(
                                            "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                                        )}
                                        alt="error"
                                        height={5}
                                        width={5}
                                    />
                                </span>
                                <span className={clsx(passwordShown ? " " : "hidden")}>
                                    <img
                                        onClick={togglePasswordVisiblity}
                                        src="assets/eye-slash-icon.svg"
                                        className={clsx(
                                            "w-4 h-4 absolute top-6 max-xxs:ml-[210px] max-sm:ml-[300px] xs:max-md:ml-[370px] md:ml-[430px]"
                                        )}
                                        alt="error"
                                        height={5}
                                        width={5}
                                    />
                                </span>
                                <input
                                    className={clsx(
                                        "mt-2"
                                    )}
                                    type={passwordShown ? "text" : "password"}
                                    id="confirmpassword"
                                    {...methods.register("confirmpassword", {
                                        onChange: (e) => {
                                            handlePasswordConfirmation(e);
                                        },
                                        required: "Confirm your password",
                                    })}
                                />
                            </div>
                        </div>
                        <div className="mt-5">
                            <label>Password Requirements</label>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="flex items-center mt-2">
                                <span className={clsx(lenCriteriaMatch ? "hidden" : "")}>
                                    <img
                                        src="assets/task-unfinished-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <span className={clsx(lenCriteriaMatch ? "" : "hidden")}>
                                    <img
                                        src="assets/success-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <p className="ml-2 password-criteria">
                                    Be 8 to 12 characters long
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="mr-5 flex items-center mt-2">
                                <span className={clsx(ucCriteriaMatch ? "hidden" : "")}>
                                    <img
                                        src="assets/task-unfinished-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <span className={clsx(ucCriteriaMatch ? "" : "hidden")}>
                                    <img
                                        src="assets/success-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <p className="ml-2 password-criteria">
                                    Include an upper case letter
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="mr-5 flex items-center mt-2">
                                <span className={clsx(lcCriteriaMatch ? "hidden" : "")}>
                                    <img
                                        src="assets/task-unfinished-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <span className={clsx(lcCriteriaMatch ? "" : "hidden")}>
                                    <img
                                        src="assets/success-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>

                                <p className="ml-2 password-criteria">
                                    Include a lower case letter
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="mr-5 flex items-center mt-2">
                                <span className={clsx(numCriteriaMatch ? "hidden" : "")}>
                                    <img
                                        src="assets/task-unfinished-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <span className={clsx(numCriteriaMatch ? "" : "hidden")}>
                                    <img
                                        src="assets/success-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <p className="ml-2 password-criteria">Include a number</p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="flex items-center mt-2">
                                <span className={clsx(scCriteriaMatch ? "hidden" : "")}>
                                    <img
                                        src="assets/task-unfinished-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <span className={clsx(scCriteriaMatch ? "" : "hidden")}>
                                    <img
                                        src="assets/success-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <p className="ml-2 password-criteria">
                                    <span>Not use the symbols: &lt; &gt; , /</span>
                                </p>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="flex items-center mt-2">
                                <span className={clsx(pwdCriteriaMatch ? "hidden" : "")}>
                                    <img
                                        src="assets/task-unfinished-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <span className={clsx(pwdCriteriaMatch ? "" : "hidden")}>
                                    <img
                                        src="assets/success-icon.svg"
                                        alt="password hidden"
                                        width={18}
                                        height={12}
                                    />
                                </span>
                                <p className="ml-2 password-criteria">
                                    <span>Passwords Match</span>
                                </p>
                            </div>
                        </div>
                        <div className="flex relative">
                            <button
                                className="primary mt-5 w-full sm:w-28 h-11 px-6"
                                disabled={resetInProgress}
                                type="submit">
                                <FontAwesomeIcon
                                    icon={faSpinner}
                                    spin
                                    style={{ marginRight: 8 }}
                                    className={clsx(resetInProgress ? "" : "hidden")}
                                />
                                Change Password
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </main>

    );
}